import { Video } from '../../api';

export const buildDataZoomContentParams = (video: Video) => {
  return {
    id: video.id,
    name: video.title,
    type: video.contentType,
  };
};
